






import { Component, Vue } from 'vue-property-decorator';
import ScavengerHunt from './components/ScavengerHunt.vue';

@Component({
  components: {
    ScavengerHunt,
  },
})
export default class App extends Vue {}
